import React, { useState, useEffect } from "react";
import { Autocomplete, Typography, TextField, FormControl, Skeleton, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../config";
import dayjs from "dayjs";

export default function CMCustomerReports(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [customerList, setCustomerList] = useState([]);
    const [CMFilter, setCMFilter] = useState({
        sort_order: "asc",
        sort_by: "cus_name",
        page: 0,
        page_size: 10,
        customer_id: null,
        dateForType: null,
        quarter: null,
        reportType: "",
        customer: {},
    });
    const [startDate, setStartDate] = useState(moment().startOf('month'));
    const [endDate, setEndDate] = useState(moment().endOf('month'));
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(false);

    const typesList = ["Monthly", "Quarterly", "Yearly"];
    const quarterList = [`Q1 ${moment().year()}`, `Q2 ${moment().year()}`, `Q3 ${moment().year()}`, `Q4 ${moment().year()}`];

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        axios
            .get(APIURL + "/customers/v2/associated", {
                params: {
                    company_id: props.user.comp_id,
                    employee_id: props.user.emp_id,
                    type: props.user.permissions.AdminLevelCustomers ? "Admin" : "Manager"
                },
            })
            .then((response) => {
                setCustomerList(response?.data.filter((cus) => cus.cus_status === 'Active') || []);
                setIsLoading(false);
            });

    };

    const getReport = async (data, type) => {
        setPdfUrl(null);
        setPdfLoading(true);

        let dateType = CMFilter.reportType;
        let dateFilter;
        let fromDate;
        let toDate;

        if (dateType === 'Monthly') {
            if (CMFilter.dateForType) {
                fromDate = moment(new Date(CMFilter.dateForType)).startOf('month');
                toDate = moment(new Date(CMFilter.dateForType)).endOf('month');

                let newDate = new Date(CMFilter.dateForType);
                dateFilter = newDate.getMonth() + 1;
            }
            else {
                fromDate = moment().startOf('month');
                toDate = moment().endOf('month');

                let newDate = new Date();
                dateFilter = newDate.getMonth() + 1;
            }
        } else if (dateType === 'Quarterly') {
            const newDate = new Date();
            const year = newDate.getFullYear();

            let quarterStartMonth, quarterEndMonth;

            switch (CMFilter.quarter) {
                case `Q1 ${moment().year()}`:
                    quarterStartMonth = 0;  // January
                    quarterEndMonth = 2;    // March
                    break;
                case `Q2 ${moment().year()}`:
                    quarterStartMonth = 3;  // April
                    quarterEndMonth = 5;    // June
                    break;
                case `Q3 ${moment().year()}`:
                    quarterStartMonth = 6;  // July
                    quarterEndMonth = 8;    // September
                    break;
                case `Q4 ${moment().year()}`:
                    quarterStartMonth = 9;  // October
                    quarterEndMonth = 11;   // December
                    break;
                default:
                    quarterStartMonth = 0;  // January
                    quarterEndMonth = 2;    // March
                    break;
            }

            const quarterStart = new Date(year, quarterStartMonth, 1);
            const quarterEnd = new Date(year, quarterEndMonth + 1, 0);

            dateFilter = {
                quarterStart: quarterStart,
                quarterEnd: quarterEnd
            }

            fromDate = moment(quarterStart);
            toDate = moment(quarterEnd);
        } else if (dateType === 'Yearly') {
            if (CMFilter.dateForType) {
                fromDate = moment(new Date(CMFilter.dateForType)).startOf('year');
                toDate = moment(new Date(CMFilter.dateForType)).endOf('year');

                let newDate = new Date(CMFilter.dateForType);
                dateFilter = newDate.getFullYear();
            }
            else {
                fromDate = moment().startOf('year');
                toDate = moment().endOf('year');

                let newDate = new Date();
                dateFilter = newDate.getFullYear();
            }
        } else if (!dateType || dateType === '') {
            dateType = 'None';
            if (startDate && endDate) {
                fromDate = moment(new Date(startDate));
                toDate = moment(new Date(endDate));

                dateFilter = {
                    start: new Date(startDate),
                    end: new Date(endDate)
                }

                dateFilter.end.setHours(23, 59, 59, 999);
            } else {
                fromDate = moment().startOf('month');
                toDate = moment().endOf('month');

                dateType = 'Monthly';
                let newDate = new Date();
                dateFilter = newDate.getMonth() + 1;
            }
        } else {
            fromDate = moment().startOf('month');
            toDate = moment().endOf('month');

            dateType = 'Monthly';
            let newDate = new Date();
            dateFilter = newDate.getMonth() + 1;
        }

        axios
            .get(APIURL + "/jsreport/cm_invoice", {
                params: {
                    com_id: props.user.comp_id,
                    cus_id: CMFilter.customer.cus_id,
                    cus_name: CMFilter.customer.cus_name,
                    dateFilter: dateFilter,
                    dateType: dateType,
                    emp_id: props.user.emp_id,
                    from: fromDate,
                    to: toDate,
                },
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/pdf",
                },
            })
            .then((response) => openPDF(response, type));
    }

    const openPDF = (response, reportAction = "open") => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);

        if (reportAction === "download") {
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = `Report-${moment().format('YYYY-MM-DD-HHmmss')}.pdf`;
            link.click();

            setPdfLoading(false);
        } else {
            setPdfUrl(fileURL);
        }
    };

    const handleFilterData = (value, key) => {
        setPdfUrl(null);

        if (key === "client") {
            setCMFilter({
                ...CMFilter,
                customer_id: value ? value.cus_id : null,
                customer: value,
            });
        } else if (key === "type") {
            setCMFilter({
                ...CMFilter,
                reportType: value,
            });
        } else if (key === "quarter") {
            setCMFilter({
                ...CMFilter,
                quarter: value,
            });
        }
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', margin: 10, marginTop: 50, width: '100%' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        )
    } else {
        return (
            <div style={{ margin: props.source === 'Company' ? 0 : 10, width: '100%' }}>
                <div>
                    <Typography
                        style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            fontFamily: "Lato",
                            marginBottom: 30,
                        }}
                    >
                        {props.source === 'Company' ? 'Service Report' : 'Case Management Reports'}
                    </Typography>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 0' }}>
                    <div>
                        <Autocomplete
                            id="client-select"
                            options={customerList}
                            getOptionLabel={(option) => option.cus_name}
                            onChange={(event, value) => handleFilterData(value, "client")}
                            renderInput={(params) => <TextField {...params} label="Select Client" />}
                            sx={{ width: 250 }}
                            size="small"
                        />
                    </div>
                    <div style={{ marginLeft: 10, marginRight: 10 }}>
                        <Autocomplete
                            id="type-select"
                            value={CMFilter.reportType}
                            options={typesList}
                            getOptionLabel={(option) => option}
                            onChange={(event, value) => handleFilterData(value, "type")}
                            renderInput={(params) => <TextField {...params} label="Select Type" />}
                            sx={{ width: 250 }}
                            size="small"
                        />
                    </div>
                    {CMFilter?.reportType === "Quarterly" &&
                        <div style={{ marginLeft: 10, marginRight: 10 }}>
                            <Autocomplete
                                id="type-select"
                                value={CMFilter.quarter}
                                options={quarterList}
                                getOptionLabel={(option) => option}
                                onChange={(event, value) => handleFilterData(value, "quarter")}
                                renderInput={(params) => <TextField {...params} label="Select Quarter" />}
                                sx={{ width: 250 }}
                                size="small"
                            />
                        </div>
                    }

                    <div>
                        <FormControl size="small" fullWidth>
                            <LocalizationProvider
                                dateAdapter={AdapterDayjs}
                                localeText={{ start: "From Date", end: "To Date" }}
                            >
                                {!CMFilter?.reportType ? (
                                    <DateRangePicker
                                        label='Date Range'
                                        value={[
                                            startDate ? dayjs(startDate) : null,
                                            endDate ? dayjs(endDate) : null,
                                        ]}
                                        onChange={(newValue) => {
                                            setStartDate(newValue[0] ? new Date(newValue[0]) : null);
                                            setEndDate(newValue[1] ? new Date(newValue[1]) : null);
                                            setCMFilter({
                                                ...CMFilter,
                                                page: 0,
                                            });
                                        }}
                                        slotProps={{ fieldSeparator: { children: 'to' }, textField: { size: 'small' } }}
                                    />
                                ) : null}
                                {CMFilter?.reportType === "Yearly" ? (
                                    <DatePicker
                                        label="Select year"
                                        openTo="year"
                                        views={['year']}
                                        value={moment(CMFilter?.dateForType).isValid() ? dayjs(CMFilter?.dateForType) : null}
                                        maxDate={dayjs(new Date())}
                                        onChange={(newValue) => {
                                            setCMFilter({
                                                ...CMFilter,
                                                page: 0,
                                                dateForType: newValue,
                                            });
                                        }}
                                        slotProps={{ textField: { variant: 'outlined', size: 'small' } }}
                                    />
                                ) : null}
                                {CMFilter?.reportType === "Monthly" ? (
                                    <DatePicker
                                        label="Select month"
                                        openTo="month"
                                        views={['month', 'year']}
                                        maxDate={dayjs(new Date())}
                                        value={moment(CMFilter?.dateForType).isValid() ? dayjs(CMFilter?.dateForType) : null}
                                        onChange={(newValue) => {
                                            setCMFilter({
                                                ...CMFilter,
                                                page: 0,
                                                dateForType: newValue,
                                            });
                                        }}
                                        slotProps={{ textField: { variant: 'outlined', size: 'small' } }}
                                    />
                                ) : null}
                            </LocalizationProvider>
                        </FormControl>
                    </div>

                    <div style={{ marginLeft: 10 }}>
                        <Button
                            onClick={(e) => {
                                getReport({}, 'open');
                            }}
                            variant="contained"
                            disabled={!CMFilter.customer_id}
                        >
                            VIEW REPORT
                        </Button>
                    </div>

                    <div style={{ marginLeft: 10 }}>
                        <Button
                            onClick={(e) => {
                                getReport({}, 'download');
                            }}
                            variant="contained"
                            disabled={!CMFilter.customer_id}
                        >
                            PDF
                        </Button>
                    </div>
                </div>
                {pdfLoading &&
                    <div style={{ marginTop: 30, }}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            width={'100%'}
                            height={`calc(100vh - ${props.source === 'Company' ? '515px' : '250px'})`}
                            sx={{ borderRadius: '4px' }}
                        />
                    </div>
                }
                {pdfUrl &&
                    <div style={{ marginTop: 30 }}>
                        <iframe
                            src={pdfUrl}
                            style={{ width: '100%', height: `calc(100vh - ${props.source === 'Company' ? '515px' : '250px'})` }}
                            onLoad={() => setPdfLoading(false)}
                        />
                    </div>
                }
            </div>
        );
    };
}